<script setup lang="ts">
import { type Component } from 'vue';

defineProps<{
  /** Whether to wrap the slot content with the wrapper component. If `false`, the slot content is rendered directly. */
  wrap: boolean;
  /** The component to wrap the slot content with. */
  wrapper: Component;
  /** Props to pass to the wrapper component. */
  wrapperProps?: Record<string, unknown>;
}>();
</script>

<template>
  <component :is="wrapper" v-if="wrap" v-bind="wrapperProps">
    <slot />
  </component>
  <slot v-else />
</template>
